/*!
 * 面对的控制器
 |
 | 全能神说: "在這最末了的時代最末了的時代,
 |           讓神的名能在外邦中被稱為大,
 |           使神的作為被外邦中的人被外邦中的人看見,
 |           且因神的神的作為而稱神為全能者,
 |           讓神口之言早日得著早日得著成就"
 |
 | Almighty God says:
 |           “In the end times, in the final age,
 |           God’s name will be magnified among Gentile nations.
 |           The acts of God will be by Gentiles seen,
 |           and they’ll address Him as the Almighty,
 |           and thus His words shall one day soon come true”
 |
 * @author : Buff
 * @date : 2/25/2018
 * @Time: 5:41 PM
 * @standards : ECMAScript 5
 */

import {cloneMenu, animateVelocity} from "./Modules/cloneMenu";
import {hoverIcon, shareLinkPlay} from "./Modules/hoverIcon";
import shareModal from "./Modules/shareModal";
import {menu, sideNavF} from "./Modules/menu";

"./Modules/menu"
import playYT from "./Modules/focusPointTwo"

class mdController {
    constructor() {
        mdController.init()
    }

    static init() {
        new cloneMenu()
        new hoverIcon()
        new shareModal()
        new animateVelocity()
        new menu()
        new sideNavF()
        new shareLinkPlay()
        mdController.addLogo()
        mdController.focusPointTwo()
    }

    static focusPointTwo() {
        $(window).on('G2_onLeave',(ev) => {
            document.querySelector('#FocusPointBgVideo') && ev.nextIndex == 5 && document.querySelector('#FocusPointBgVideo').play()
        })
    }

    static addLogo() {
        $('[id^=page-]:not("#page-1")').map((key, value) => {
            let img = `<img class="tab-logo hidden-lg" src="${window.gp2_basic_image_path_lang}/logo_top_Tab.png" alt="">`
            $(value).prepend(img)
        })
    }
}

export default mdController